import { render, staticRenderFns } from "./BindUSDTAcc.vue?vue&type=template&id=c9081450&scoped=true"
import script from "./BindUSDTAcc.vue?vue&type=script&lang=js"
export * from "./BindUSDTAcc.vue?vue&type=script&lang=js"
import style0 from "./BindUSDTAcc.vue?vue&type=style&index=0&id=c9081450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9081450",
  null
  
)

export default component.exports